module.exports = __webpack_public_path__ + "assets/openssl.af63f764.svg";